import AppRouter from './presentation/routes/AppRouter';
import ErrorBoundary from './shared/components/ErrorBoundary';

const App = () => {
  return (
    <ErrorBoundary>
      <AppRouter />
    </ErrorBoundary>
  );
};

export default App;
